module.exports = __webpack_public_path__ + "img/quick-icon02.c4efc9fa.png";